import { createWithEqualityFn } from 'zustand/traditional';
import { shallow } from 'zustand/shallow';

export const useNotificationOpenStateStore = createWithEqualityFn<{
  open: boolean;
  cursor_connections_id: Array<number>;
}>(
  () => ({
    open: false,
    cursor_connections_id: [],
  }),
  shallow
);

export const toggleCursorConnections = (connectionId: number) => {
  useNotificationOpenStateStore.setState((state) => ({
    ...state,
    cursor_connections_id: state.cursor_connections_id.includes(connectionId)
      ? state.cursor_connections_id.filter((i) => i !== connectionId)
      : [...state.cursor_connections_id, connectionId],
  }));
};

export const useCursorConnections = () =>
  useNotificationOpenStateStore((state) => state.cursor_connections_id, shallow);
